/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { attachmentsControllerAddAttachment } from '../fn/allegati/attachments-controller-add-attachment';
import { AttachmentsControllerAddAttachment$Params } from '../fn/allegati/attachments-controller-add-attachment';
import { attachmentsControllerCreate } from '../fn/allegati/attachments-controller-create';
import { AttachmentsControllerCreate$Params } from '../fn/allegati/attachments-controller-create';
import { attachmentsControllerDelete } from '../fn/allegati/attachments-controller-delete';
import { AttachmentsControllerDelete$Params } from '../fn/allegati/attachments-controller-delete';
import { attachmentsControllerDeleteAttachment } from '../fn/allegati/attachments-controller-delete-attachment';
import { AttachmentsControllerDeleteAttachment$Params } from '../fn/allegati/attachments-controller-delete-attachment';
import { attachmentsControllerDownloadAllAttachments } from '../fn/allegati/attachments-controller-download-all-attachments';
import { AttachmentsControllerDownloadAllAttachments$Params } from '../fn/allegati/attachments-controller-download-all-attachments';
import { attachmentsControllerFindOne } from '../fn/allegati/attachments-controller-find-one';
import { AttachmentsControllerFindOne$Params } from '../fn/allegati/attachments-controller-find-one';
import { attachmentsControllerGetAll } from '../fn/allegati/attachments-controller-get-all';
import { AttachmentsControllerGetAll$Params } from '../fn/allegati/attachments-controller-get-all';
import { attachmentsControllerGetAllAttachments } from '../fn/allegati/attachments-controller-get-all-attachments';
import { AttachmentsControllerGetAllAttachments$Params } from '../fn/allegati/attachments-controller-get-all-attachments';
import { attachmentsControllerUpdate } from '../fn/allegati/attachments-controller-update';
import { AttachmentsControllerUpdate$Params } from '../fn/allegati/attachments-controller-update';
import { AttachmentsItem } from '../models/attachments-item';
import { AttachmentsListResponse } from '../models/attachments-list-response';
import { BaseResponse } from '../models/base-response';
import { EmptyResponse } from '../models/empty-response';
import { EntityAttachmentsListResponse } from '../models/entity-attachments-list-response';

@Injectable({ providedIn: 'root' })
export class AllegatiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `attachmentsControllerDownloadAllAttachments()` */
  static readonly AttachmentsControllerDownloadAllAttachmentsPath = '/attachments/{entity}/{entity_media_type}/download-all';

  /**
   * Recupera allegati dell'entità per id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `attachmentsControllerDownloadAllAttachments()` instead.
   *
   * This method doesn't expect any request body.
   */
  attachmentsControllerDownloadAllAttachments$Response(params: AttachmentsControllerDownloadAllAttachments$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return attachmentsControllerDownloadAllAttachments(this.http, this.rootUrl, params, context);
  }

  /**
   * Recupera allegati dell'entità per id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `attachmentsControllerDownloadAllAttachments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  attachmentsControllerDownloadAllAttachments(params: AttachmentsControllerDownloadAllAttachments$Params, context?: HttpContext): Observable<Blob> {
    return this.attachmentsControllerDownloadAllAttachments$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `attachmentsControllerAddAttachment()` */
  static readonly AttachmentsControllerAddAttachmentPath = '/attachments/{entity}/{id}/{type}';

  /**
   * Aggiungi allegato all'entità per id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `attachmentsControllerAddAttachment()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  attachmentsControllerAddAttachment$Response(params: AttachmentsControllerAddAttachment$Params, context?: HttpContext): Observable<StrictHttpResponse<EmptyResponse>> {
    return attachmentsControllerAddAttachment(this.http, this.rootUrl, params, context);
  }

  /**
   * Aggiungi allegato all'entità per id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `attachmentsControllerAddAttachment$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  attachmentsControllerAddAttachment(params: AttachmentsControllerAddAttachment$Params, context?: HttpContext): Observable<EmptyResponse> {
    return this.attachmentsControllerAddAttachment$Response(params, context).pipe(
      map((r: StrictHttpResponse<EmptyResponse>): EmptyResponse => r.body)
    );
  }

  /** Path part for operation `attachmentsControllerGetAllAttachments()` */
  static readonly AttachmentsControllerGetAllAttachmentsPath = '/attachments/{entity}/{id}';

  /**
   * Recupera allegati dell'entità per id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `attachmentsControllerGetAllAttachments()` instead.
   *
   * This method doesn't expect any request body.
   */
  attachmentsControllerGetAllAttachments$Response(params: AttachmentsControllerGetAllAttachments$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EntityAttachmentsListResponse;
}>> {
    return attachmentsControllerGetAllAttachments(this.http, this.rootUrl, params, context);
  }

  /**
   * Recupera allegati dell'entità per id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `attachmentsControllerGetAllAttachments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  attachmentsControllerGetAllAttachments(params: AttachmentsControllerGetAllAttachments$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EntityAttachmentsListResponse;
}> {
    return this.attachmentsControllerGetAllAttachments$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EntityAttachmentsListResponse;
}>): BaseResponse & {
'data'?: EntityAttachmentsListResponse;
} => r.body)
    );
  }

  /** Path part for operation `attachmentsControllerDeleteAttachment()` */
  static readonly AttachmentsControllerDeleteAttachmentPath = '/attachments/{entity}/{id}/{type}/{media_id}';

  /**
   * Elimina un allegato.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `attachmentsControllerDeleteAttachment()` instead.
   *
   * This method doesn't expect any request body.
   */
  attachmentsControllerDeleteAttachment$Response(params: AttachmentsControllerDeleteAttachment$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EntityAttachmentsListResponse;
}>> {
    return attachmentsControllerDeleteAttachment(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina un allegato.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `attachmentsControllerDeleteAttachment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  attachmentsControllerDeleteAttachment(params: AttachmentsControllerDeleteAttachment$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EntityAttachmentsListResponse;
}> {
    return this.attachmentsControllerDeleteAttachment$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EntityAttachmentsListResponse;
}>): BaseResponse & {
'data'?: EntityAttachmentsListResponse;
} => r.body)
    );
  }

  /** Path part for operation `attachmentsControllerGetAll()` */
  static readonly AttachmentsControllerGetAllPath = '/attachments';

  /**
   * Restituisce l'elenco degli stati allegati.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `attachmentsControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  attachmentsControllerGetAll$Response(params: AttachmentsControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AttachmentsListResponse;
}>> {
    return attachmentsControllerGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco degli stati allegati.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `attachmentsControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  attachmentsControllerGetAll(params: AttachmentsControllerGetAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AttachmentsListResponse;
}> {
    return this.attachmentsControllerGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AttachmentsListResponse;
}>): BaseResponse & {
'data'?: AttachmentsListResponse;
} => r.body)
    );
  }

  /** Path part for operation `attachmentsControllerCreate()` */
  static readonly AttachmentsControllerCreatePath = '/attachments';

  /**
   * Crea uno stato allegato.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `attachmentsControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  attachmentsControllerCreate$Response(params: AttachmentsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AttachmentsItem;
}>> {
    return attachmentsControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea uno stato allegato.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `attachmentsControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  attachmentsControllerCreate(params: AttachmentsControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AttachmentsItem;
}> {
    return this.attachmentsControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AttachmentsItem;
}>): BaseResponse & {
'data'?: AttachmentsItem;
} => r.body)
    );
  }

  /** Path part for operation `attachmentsControllerFindOne()` */
  static readonly AttachmentsControllerFindOnePath = '/attachments/{id}';

  /**
   * Restituisce uno stato allegato.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `attachmentsControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  attachmentsControllerFindOne$Response(params: AttachmentsControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AttachmentsItem;
}>> {
    return attachmentsControllerFindOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce uno stato allegato.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `attachmentsControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  attachmentsControllerFindOne(params: AttachmentsControllerFindOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AttachmentsItem;
}> {
    return this.attachmentsControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AttachmentsItem;
}>): BaseResponse & {
'data'?: AttachmentsItem;
} => r.body)
    );
  }

  /** Path part for operation `attachmentsControllerDelete()` */
  static readonly AttachmentsControllerDeletePath = '/attachments/{id}';

  /**
   * Elimina uno stato allegato.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `attachmentsControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  attachmentsControllerDelete$Response(params: AttachmentsControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AttachmentsItem;
}>> {
    return attachmentsControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina uno stato allegato.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `attachmentsControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  attachmentsControllerDelete(params: AttachmentsControllerDelete$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AttachmentsItem;
}> {
    return this.attachmentsControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AttachmentsItem;
}>): BaseResponse & {
'data'?: AttachmentsItem;
} => r.body)
    );
  }

  /** Path part for operation `attachmentsControllerUpdate()` */
  static readonly AttachmentsControllerUpdatePath = '/attachments/{id}';

  /**
   * Modifica uno stato allegato.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `attachmentsControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  attachmentsControllerUpdate$Response(params: AttachmentsControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AttachmentsItem;
}>> {
    return attachmentsControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica uno stato allegato.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `attachmentsControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  attachmentsControllerUpdate(params: AttachmentsControllerUpdate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AttachmentsItem;
}> {
    return this.attachmentsControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AttachmentsItem;
}>): BaseResponse & {
'data'?: AttachmentsItem;
} => r.body)
    );
  }

}
